
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21.722.333H2.278c-1.072 0-1.945.883-1.945 1.97v13.124c0 1.086.873 1.969 1.945 1.969h1.944v3.281a.657.657 0 0 0 .648.656.645.645 0 0 0 .459-.192l3.699-3.745h12.694c1.073 0 1.945-.883 1.945-1.969V2.302c0-1.086-.872-1.969-1.945-1.969z","fill":"#8296A0"}})])
      }
    
      }
    